module.exports = __webpack_public_path__ + "img/lightbulb-03.3a1950db.svg";